import { ReactFlowProvider } from '@xyflow/react';

import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import ErrorPage from '../components/common/error-page.component';
import DiagramLoading from '../components/diagram/container/diagram-loading.component';
import Diagram from '../components/diagram/diagram.component';
import Header from '../components/header/header.component';
import { generateNodesAndEdges } from '../helpers/node-edge-generator';
import useDiagramData from '../hooks/use-diagram-data';
import useDiagramFilterData from '../hooks/use-diagram-filter-data';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { initState, selectDiagramDisabled } from '../redux/slices/diagram';

function Main() {
  const { loading, error, diagramData } = useDiagramData();
  const { loading: loadingFilters, diagramFilterData } = useDiagramFilterData();
  const dispatch = useAppDispatch();
  const initedRef = useRef(false);
  const disableDiagram = useAppSelector(selectDiagramDisabled);
  const navigate = useNavigate();

  useEffect(() => {
    if (!initedRef.current && !loading && diagramData && !loadingFilters) {
      initedRef.current = true;
      const { nodes, edges } = generateNodesAndEdges(diagramData, diagramFilterData);
      dispatch(initState({ ...diagramData, nodes, edges, filter: diagramFilterData }));
    }
  }, [loading, diagramData, loadingFilters, diagramFilterData]);

  const handleReloadOnError = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <div className="bt-flex bt-flex-col" style={{ width: '100vw', height: '100vh' }}>
      {!diagramData && !error && <DiagramLoading loading={loading} />}
      {diagramData && !loading && !error && (
        <ReactFlowProvider>
          <Header />
          <div className="bt-relative bt-h-full bt-w-full">
            {disableDiagram && <div className="bt-absolute bt-z-[1] bt-h-full bt-w-full bt-bg-transparent" />}
            <Diagram />
          </div>
        </ReactFlowProvider>
      )}
      {!loading && error && (
        <ErrorPage
          message="Unable to load diagram. Please try again later."
          actionLabel="Go Home"
          onActionClick={handleReloadOnError}
        />
      )}
    </div>
  );
}

export default React.memo(Main);
